export default async function deleteNode({ state, graphql }) {
  const path = state.get('node.deleteNode')
  const node = state.get(path)
  await graphql.mutate(`{deleteNode(id: "${node.id}")}`)
  return { id: node.id }
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/deleteNode.js